"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RequireAuth_1 = __importDefault(require("@Components/RequireAuth"));
const react_1 = __importDefault(require("react"));
const SongwriterLayout_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterLayout"));
const SongwriterCatalogBuilderScene_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene"));
const SongwriterCatalogScene_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogScene"));
const ViewWorkSongwriterScene_1 = __importDefault(require("@Scenes/WorkScenes/ViewWorkSongwriterScene"));
const SongwriterCatalogLayout_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogLayout"));
const SongwriterMyWritersScene_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterMyWritersScene"));
const SongwriterViewSearchedWorkScene_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterViewSearchedWorkScene"));
const route_1 = require("@App/navigation/route");
const CowriterSearchScene_1 = __importDefault(require("@Scenes/SongwriterScene/CowriterSearch/CowriterSearchScene"));
const createSongwriterRoutes = () => ({
    path: route_1.SONGWRITER_ROUTE_WITH_ID,
    element: (react_1.default.createElement(RequireAuth_1.default, null,
        react_1.default.createElement(SongwriterLayout_1.default, null))),
    children: [
        {
            path: route_1.SONGWRITER_SUB_ROUTES.link,
            element: react_1.default.createElement(SongwriterCatalogBuilderScene_1.default, null),
        },
        {
            path: route_1.SONGWRITER_SUB_ROUTES.myWriters,
            element: react_1.default.createElement(SongwriterMyWritersScene_1.default, null),
        },
        {
            path: route_1.SONGWRITER_SUB_ROUTES.searchedWork,
            element: react_1.default.createElement(SongwriterViewSearchedWorkScene_1.default, null),
        },
        {
            path: route_1.SONGWRITER_SUB_ROUTES.searchedWork,
            element: react_1.default.createElement(SongwriterViewSearchedWorkScene_1.default, null),
        },
        {
            path: route_1.SONGWRITER_SUB_ROUTES.cowriters.root,
            element: react_1.default.createElement(CowriterSearchScene_1.default, null),
            children: [
                {
                    path: route_1.SONGWRITER_SUB_ROUTES.cowriters.search,
                    element: react_1.default.createElement(CowriterSearchScene_1.default, null),
                },
            ],
        },
        {
            path: '',
            element: react_1.default.createElement(SongwriterCatalogLayout_1.default, null),
            children: [
                {
                    path: route_1.SONGWRITER_SUB_ROUTES.catalog.root,
                    element: react_1.default.createElement(SongwriterCatalogScene_1.default, null),
                },
                {
                    path: route_1.SONGWRITER_SUB_ROUTES.catalog.viewWork,
                    element: react_1.default.createElement(ViewWorkSongwriterScene_1.default, null),
                },
            ],
        },
    ],
});
exports.default = createSongwriterRoutes;
